export default __webpack_public_path__ + "static/CentraNo2-LightItalic-2c5050f8b11a457f73dd5bff0bec6d32.woff2";